export interface Identities {
  linkedGoogleAccountId: string;
  linkedGithubAccountId: string;
  linkedFacebookAccountId: string;
  linkedLinkedinAccountId: string;
}
